<template>
	<div>
		<taskyType :type="7" />
	</div>
</template>

<script>
import taskyType from '@/components/taskyType/taskyType';
export default {
	components: {
		taskyType
	}
};
</script>

<style></style>
